import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment'
import { response } from '../../optDetail';

@Injectable()
export class ResponseService {
  private responseURL = `${environment.defaultURL}/v2/response/` ;
  constructor(private http: HttpClient) {
  }

  saveResponse(resp: response): Observable<response>{
      let url = `${this.responseURL}`;
      resp.source = 'Web';
    const httpOptions = { headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    return this.http.post<response>(url, resp, httpOptions);
  }
}
